export class CameraLocation {
  latitude;
  longitude;
  constructor(location) {
    this.latitude = +location?.latitude || 0;
    this.longitude = +location?.longitude || 0;
  }
}
